import React, { useMemo } from "react";
import { useFormState } from "react-final-form";
import { WarningAmber } from "@mui/icons-material";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { CameraExpressionField } from "fond/styleEditor";
import { StyleField } from "fond/types";
import { NonIdealState } from "fond/widgets";

import { FieldFactory } from "../FieldFactory";
import { getDefaultSpecValue, valueType } from "../helper";

interface IProps {
  field: StyleField;
  fieldSpec?: any;
}

export const useCustomStyles = makeStyles((theme: Theme) => ({}));

const Field: React.FC<IProps> = ({ field, fieldSpec }: IProps) => {
  const { values } = useFormState();
  const { fieldName } = field;
  const defaultValue = useMemo(() => getDefaultSpecValue(fieldSpec, fieldName), [fieldName]);
  const fieldType = useMemo(() => valueType(values, fieldName), [values, fieldName]);

  if (fieldType === "cameraExpression")
    return <CameraExpressionField name={`${fieldName}Interpolate`} field={field} fieldSpec={fieldSpec} defaultValue={defaultValue} />;
  if (fieldType === "dataExpression")
    return (
      <NonIdealState
        size="small"
        title="Editing not supported"
        description="Currently the ability to edit data driven styling is not supported."
        icon={<WarningAmber />}
      />
    );

  return <FieldFactory fieldName={fieldName} formFieldName={fieldName} fieldSpec={fieldSpec} defaultValue={defaultValue} />;
};

export default Field;
